module.exports = {"customers":{"wallet":{"update":{"description":"Interna opomba (opis)"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/apps/loyaltyvenue/i18n/sl.json
// module id = 2uL4
// module chunks = 13